{
  "enum": {
    "ExcJpmamV1Action": {
      "FULL_REDEMPTION": "Full Redemption",
      "PURCHASE": "Purchase",
      "REDEEM": "Redeem",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1DestinationStatus": {
      "AVAILABLE": "Available",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1JpmamJobStatus": {
      "DONE": "Done",
      "OPEN": "Open",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1JpmamOrderStatus": {
      "CANCELED": "Canceled",
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1JpmamTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1NetOrderStatus": {
      "ASSEMBLING": "Assembling",
      "CANCELED": "Canceled",
      "CONFIRMED": "Confirmed",
      "PENDING": "Pending",
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1OperationType": {
      "ORDER_REASSIGN": "Order Reassign",
      "ORDER_STATE_PROPAGATE": "Order State Propagate",
      "ORDER_STATUS_NOTIFY": "Order Status Notify",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1OrderUnit": {
      "CASH": "Cash",
      "SHARES": "Shares",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1ProcessType": {
      "FULL": "Full",
      "PURCHASE": "Purchase",
      "REDEEM": "Redeem",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcJpmamV1TaskUpdatedStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcJpmamV1DestinationQueryServiceDestinationListFilterableFields": {
      "data": {
        "spec": {
          "assetId": "Asset"
        }
      },
      "destinationId": "Destination",
      "status": "Status"
    },
    "ExcJpmamV1JpmamJobQueryServiceJpmamJobListFilterableFields": {
      "jpmamJobId": "Job",
      "status": "Status"
    },
    "ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListFilterableFields": {
      "data": {
        "spec": {
          "action": "Action",
          "assetId": "Asset",
          "source": {
            "!type": "Source"
          },
          "unit": "Unit"
        }
      },
      "orderId": "Order",
      "status": "Status"
    },
    "ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListFilterableFields": {
      "jpmamJobId": "Job",
      "jpmamTaskId": "Task",
      "referenceId": "Reference ID",
      "status": "Status"
    },
    "ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "groupingId": "Grouping ID",
        "source": {
          "!type": "Source"
        },
        "unit": "Unit"
      },
      "netOrderId": "Net Order",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcJpmamV1DestinationEventType": {
      "created": "Created",
      "updated": "Updated"
    },
    "ExcJpmamV1JobCreatedInfo": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1JobSpec": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1JobStats": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1JobTasksAddInfo": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1JpmamJobEventType": {
      "allFinished": "All Finished",
      "closed": "Closed",
      "created": "Created",
      "taskUpdated": "Task Updated",
      "tasksAdd": "Tasks Add"
    },
    "ExcJpmamV1JpmamOrderEventType": {
      "assigned": "Assigned",
      "canceled": "Canceled",
      "posted": "Posted",
      "reassigned": "Reassigned",
      "rejected": "Rejected",
      "settled": "Settled"
    },
    "ExcJpmamV1JpmamTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished",
      "started": "Started"
    },
    "ExcJpmamV1NetOrderEventType": {
      "assembled": "Assembled",
      "batchUpdated": "Batch Updated",
      "canceled": "Canceled",
      "confirmed": "Confirmed",
      "created": "Created",
      "deferralStarted": "Deferral Started",
      "manuallyPosted": "Manually Posted",
      "orderCanceled": "Order Canceled",
      "paymentSent": "Payment Sent",
      "posted": "Posted",
      "rejected": "Rejected",
      "settled": "Settled",
      "updated": "Updated"
    },
    "ExcJpmamV1NetOrderSource": {
      "customer": "Customer",
      "sweep": "Sweep"
    },
    "ExcJpmamV1OrderSource": {
      "customer": "Customer",
      "sweep": "Sweep"
    },
    "ExcJpmamV1PaymentTransferType": {
      "wirePush": "Wire Push"
    },
    "ExcJpmamV1TaskCreatedInfo": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1TaskFinishedInfo": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1TaskSpec": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1TaskStartedInfo": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1TaskUpdatedData": {
      "orderReassign": "Order Reassign",
      "orderStatePropagate": "Order State Propagate",
      "orderStatusNotify": "Order Status Notify"
    },
    "ExcJpmamV1TransferType": {
      "wirePush": "Wire Push"
    }
  },
  "searchEnum": {
    "ExcJpmamV1DestinationQueryServiceDestinationListSearchableFields": {
      "data": {
        "spec": {
          "bankDetails": {
            "accountNumber": "Data Spec Bank Details Account Number"
          }
        }
      }
    }
  },
  "sortEnum": {
    "ExcJpmamV1DestinationQueryServiceDestinationListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcJpmamV1JpmamJobQueryServiceJpmamJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcJpmamV1JpmamOrderQueryServiceJpmamOrderListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcJpmamV1JpmamTaskQueryServiceJpmamTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcJpmamV1NetOrderQueryServiceNetOrderListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}